export default "__VITE_ASSET__CraUjoJq__"